import { MODAL_HEADER_ON_CANCELLATION_FAILURE, MODAL_BODY_ON_CANCELLATION_FAILURE } from 'config/constants';
import * as track from 'lib/gaTracking/crossPageEvents';
import { useCallback } from 'react';
import { useDetailsBooking } from './useDetailsBooking';
import { useHistory } from 'react-router';
import { getBookingDetailsPageLink } from 'lib/links';
import useModal from 'hooks/useModal';

export const useCancellationErrorModal = () => {
  const { showModal } = useModal();
  const { replace } = useHistory();
  const { booking } = useDetailsBooking();

  return useCallback(
    () =>
      showModal({
        variant: 'error',
        header: MODAL_HEADER_ON_CANCELLATION_FAILURE,
        body: MODAL_BODY_ON_CANCELLATION_FAILURE,
        onClose: () => {
          track.modalCloseButton();
          replace(getBookingDetailsPageLink(booking.id));
        },
      }),
    [showModal, booking.id, replace],
  );
};
